
import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useAuth } from "@/contexts/auth";
import { checkPremiumStatusSync } from "@/App";
import { GuestGallery } from "@/components/gallery/GuestGallery";
import { UserGallery } from "@/components/gallery/UserGallery";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

const Gallery = () => {
  const { user } = useAuth();
  const isPremium = checkPremiumStatusSync();
  const { language } = useLanguage();
  
  // Show gallery with sample images for guest users
  if (!user) {
    return (
      <>
        <Helmet>
          <title>Baby Photo Gallery - Store Precious Moments | LittleAI Diary</title>
          <meta name="description" content="Create beautiful photo collections of your baby's growth and milestones. Store, organize and share precious memories with LittleAI Diary's photo gallery." />
          <meta name="keywords" content="baby photos, milestone pictures, baby gallery, pregnancy photos, family albums, baby memories, newborn photos" />
          <link rel="canonical" href="https://littleaidiary.com/gallery" />
          <meta property="og:title" content="Baby Photo Gallery - Store Precious Moments | LittleAI Diary" />
          <meta property="og:description" content="Create beautiful photo collections of your baby's growth and milestones. Store, organize and share precious memories." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://littleaidiary.com/gallery" />
          <meta property="og:image" content="https://lovable.dev/opengraph-image-p98pqg.png" />
        </Helmet>
        <Header />
        <GuestGallery />
        <Footer />
      </>
    );
  }

  // User is logged in, show user gallery (with premium features if premium)
  return (
    <main className="min-h-screen pt-24 pb-16">
      <Helmet>
        <title>{t('gallery.title', language)} - Store and Share Baby Photos | LittleAI Diary</title>
        <meta name="description" content="Organize and cherish your baby's photos in your personal gallery. Track growth milestones, pregnancy journey, and special moments in one secure place." />
        <meta name="keywords" content="baby photos, milestone pictures, baby gallery, pregnancy photos, family albums, baby development, growth tracking" />
        <link rel="canonical" href="https://littleaidiary.com/gallery" />
        <meta property="og:title" content={`${t('gallery.title', language)} - LittleAI Diary`} />
        <meta property="og:description" content="Organize and cherish your baby's photos in your personal gallery. Track growth milestones and special moments." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://littleaidiary.com/gallery" />
        <meta property="og:image" content="https://lovable.dev/opengraph-image-p98pqg.png" />
      </Helmet>
      <Header />
      <UserGallery userId={user.id} isPremium={isPremium} />
      <Footer />
    </main>
  );
};

export default Gallery;
